import { useMemo } from 'react';
import { useAuth } from 'services/login/hooks';
import links from 'utils/links';
import { PERMISSIONS } from 'utils/permissions';

// Add an entry to expose a new admin area to anyone who has its permission.
export const ADMIN_SECTIONS = [
  {
    icon: 'user',
    id: 'users',
    labelKey: 'users',
    path: links.users(),
    permission: PERMISSIONS.USERS_LIST,
  },
  {
    icon: 'cog',
    id: 'features',
    labelKey: 'features',
    path: links.features(),
    permission: PERMISSIONS.FEATURES_MANAGE,
  },
] as const;

export type AdminSection = typeof ADMIN_SECTIONS[number];

export const getVisibleAdminSections = (
  permissions: readonly string[] | undefined,
) => ADMIN_SECTIONS.filter(section => permissions?.includes(section.permission));

export const useAdminSections = () => {
  const { user } = useAuth();

  return useMemo(
    () => getVisibleAdminSections(user?.permissions),
    [user?.permissions],
  );
};
